import axios from 'axios';

export class OrderMatrix {
    init() {
        this.load();
    }

    async load() {
        let modelNo            = document.querySelector('.product').dataset.modelno,
            orderMatrixWrapper = document.querySelector('.ordermatrix-wrapper');

        if (orderMatrixWrapper) {
            await axios.get('/catalog/ordermatrix/' + modelNo, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(apiResponse => {
                orderMatrixWrapper.innerHTML = apiResponse.data;

                document.dispatchEvent(new CustomEvent('order-matrix-loaded', { modelNo: modelNo }));

                update_shoppingcart();
            });
        }
    }
}
